(function () {
  // Restore native console methods for Map Window
  // The SDK overrides console methods; we restore native ones via a hidden iframe.
  // The iframe must remain in the DOM for console references to stay valid.
  if (window.location.pathname.includes('mapwindow')) {
    try {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.setAttribute('aria-hidden', 'true');
      document.body.appendChild(iframe);

      // Overwrite the hijacked console with the browser's native one
      window.console.log = iframe.contentWindow.console.log;
      window.console.info = iframe.contentWindow.console.info;
      window.console.debug = iframe.contentWindow.console.debug;
    } catch (e) {
      // Console restoration failed - log with potentially hijacked console
      if (window.console && window.console.warn) {
        window.console.warn('Failed to restore native console in popup window');
      }
    }
  }
})();

import { Toaster } from '@/components/ui/sonner/sonner';
import { Loader } from '@/components/shared/loader/Loader';
import './index.css';
import './app/lib/i18n';
import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const App = lazy(() => import('@/App'));
const PopMapWindow = lazy(() => import('@/pages/PopMap/PopMapWindow'));

const container = document.getElementById('root');
const root = createRoot(container);

function Root() {
  return (
    <div className="bg-gray-800 w-screen h-screen">
      <Routes>
        {/* Main application, includes AppProviders inside */}
        <Route
          path="/"
          element={
            <Suspense fallback={<Loader />}>
              <App />
            </Suspense>
          }
        />

        <Route
          path="/mapwindow"
          element={
            <Suspense fallback={<div>Loading Map Window...</div>}>
              <PopMapWindow />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

root.render(
  <React.StrictMode>
    <Router>
      <Root />
      <Toaster richColors position="top-right" offset={{ top: 70, right: 24 }} />
    </Router>
  </React.StrictMode>
);
